import {
  CLEAR_REFERENCE_INFO,
  REFERENCE_INFO_EARTHQUAKE_DELETE_REQUEST,
  REFERENCE_INFO_EARTHQUAKE_REQUEST,
  REFERENCE_INFO_EARTHQUAKE_SORT,
  REFERENCE_INFO_EARTHQUAKE_TOGGLE_COLUMN,
  REFERENCE_INFO_REQUEST,
  REFERENCE_INFO_RUNUP_DELETE_REQUEST,
  REFERENCE_INFO_RUNUP_REQUEST,
  REFERENCE_INFO_RUNUP_SORT,
  REFERENCE_INFO_RUNUP_TOGGLE_COLUMN,
  REFERENCE_INFO_TSUNAMI_DELETE_REQUEST,
  REFERENCE_INFO_TSUNAMI_REQUEST,
  REFERENCE_INFO_TSUNAMI_SORT,
  REFERENCE_INFO_TSUNAMI_TOGGLE_COLUMN,
  REFERENCE_INFO_VOLCANO_DELETE_REQUEST,
  REFERENCE_INFO_VOLCANO_REQUEST,
  REFERENCE_INFO_VOLCANO_SORT,
  REFERENCE_INFO_VOLCANO_TOGGLE_COLUMN,
} from './referenceInfoReducer';


export const clearReferenceInfo = () => ({ type: CLEAR_REFERENCE_INFO });
export const getReference = ({ id, history }) => ({ type: REFERENCE_INFO_REQUEST, id, history });
export const getVolcanoes = ({ id, history }) => ({ type: REFERENCE_INFO_VOLCANO_REQUEST, id, history });
export const getEarthquakes = ({ id, history }) => ({ type: REFERENCE_INFO_EARTHQUAKE_REQUEST, id, history });
export const getTsunamis = ({ id, history }) => ({ type: REFERENCE_INFO_TSUNAMI_REQUEST, id, history });
export const getRunups = ({ id, history }) => ({ type: REFERENCE_INFO_RUNUP_REQUEST, id, history });
export const sortVolcanoes = sort => ({ type: REFERENCE_INFO_VOLCANO_SORT, sort });
export const sortEarthquakes = sort => ({ type: REFERENCE_INFO_EARTHQUAKE_SORT, sort });
export const sortTsunamis = sort => ({ type: REFERENCE_INFO_TSUNAMI_SORT, sort });
export const sortRunups = sort => ({ type: REFERENCE_INFO_RUNUP_SORT, sort });
export const deleteVolcano = ({ id, history }) => ({ type: REFERENCE_INFO_VOLCANO_DELETE_REQUEST, id, history });
export const deleteEarthquake = ({ id, history }) => ({ type: REFERENCE_INFO_EARTHQUAKE_DELETE_REQUEST, id, history });
export const deleteTsunami = ({ id, history }) => ({ type: REFERENCE_INFO_TSUNAMI_DELETE_REQUEST, id, history });
export const deleteRunup = ({ id, history }) => ({ type: REFERENCE_INFO_RUNUP_DELETE_REQUEST, id, history });
export const toggleVolcanoColumns = visibleColumns => ({ type: REFERENCE_INFO_VOLCANO_TOGGLE_COLUMN, visibleColumns });
export const toggleEarthquakeColumns = visibleColumns => ({ type: REFERENCE_INFO_EARTHQUAKE_TOGGLE_COLUMN, visibleColumns });
export const toggleTsunamiColumns = visibleColumns => ({ type: REFERENCE_INFO_TSUNAMI_TOGGLE_COLUMN, visibleColumns });
export const toggleRunupColumns = visibleColumns => ({ type: REFERENCE_INFO_RUNUP_TOGGLE_COLUMN, visibleColumns });
